import CompanyInfo from './CompanyInfo-view';

export default CompanyInfo;
